"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CourierAppResource = exports.CouriersResource = void 0;
/** Dispatcher-side courier management (TZ §23-§28). */
class CouriersResource {
    http;
    constructor(http) {
        this.http = http;
    }
    list(query) {
        return this.http.getPaginated('couriers', { query });
    }
    get(id) {
        return this.http.get(`couriers/${id}`);
    }
    create(payload) {
        return this.http.post('couriers', payload);
    }
    update(id, payload) {
        return this.http.patch(`couriers/${id}`, payload);
    }
    /** Live positions for the dispatcher map. */
    liveLocations(branchId) {
        return this.http.get('couriers/live', { query: { branchId } });
    }
    wallet(courierId) {
        return this.http.get(`couriers/${courierId}/wallet`);
    }
    walletTransactions(courierId, query) {
        return this.http.getPaginated(`couriers/${courierId}/wallet/transactions`, { query });
    }
    /** Puts a waiting delivery on a courier (TZ §23). */
    assign(orderId, payload) {
        return this.http.post(`orders/${orderId}/courier`, payload);
    }
    /** Gives every delivery waiting for a courier to the best free one. */
    dispatchWaiting(branchId) {
        return this.http.post('couriers/dispatch', undefined, {
            query: { branchId },
        });
    }
    /** Couriers ranked by current load, then distance. */
    suggestions(orderId) {
        return this.http.get(`orders/${orderId}/courier-suggestions`);
    }
    /**
     * Cashier confirming cash a courier declared (TZ §28).
     *
     * `amount` is what was actually counted. Omitting it accepts the declared
     * figure; sending a different one records a discrepancy rather than
     * silently overwriting the claim — that difference is the point of a
     * two-sided confirmation.
     */
    confirmHandover(handoverId, payload) {
        return this.http.post(`handovers/${handoverId}/confirm`, payload ?? {});
    }
    listHandovers(query) {
        return this.http.getPaginated('handovers', { query });
    }
}
exports.CouriersResource = CouriersResource;
/**
 * The courier mobile app's own surface.
 *
 * Every route here is scoped to the authenticated courier server-side — the
 * app never passes its own courier id, so it cannot read another's jobs.
 */
class CourierAppResource {
    http;
    constructor(http) {
        this.http = http;
    }
    /** Profile plus today's delivery count and earnings. */
    myProfile() {
        return this.http.get('courier/me');
    }
    /** Changes the number customers call — never the login phone. */
    updateMyProfile(payload) {
        return this.http.patch('courier/me', payload);
    }
    /** Jobs assigned to the signed-in courier (TZ §23). */
    myJobs() {
        return this.http.get('courier/jobs');
    }
    myJob(deliveryId) {
        return this.http.get(`courier/jobs/${deliveryId}`);
    }
    accept(deliveryId) {
        return this.http.post(`courier/jobs/${deliveryId}/accept`);
    }
    startDelivery(deliveryId) {
        return this.http.post(`courier/jobs/${deliveryId}/start`);
    }
    /** Marks delivered; `collectedCash` credits the courier's wallet. */
    complete(deliveryId, collectedCash) {
        return this.http.post(`courier/jobs/${deliveryId}/complete`, {
            collectedCash,
        });
    }
    fail(deliveryId, reason) {
        return this.http.post(`courier/jobs/${deliveryId}/fail`, { reason });
    }
    setStatus(status) {
        return this.http.post('courier/status', { status });
    }
    /** GPS ping. Sent only while the courier has granted permission (TZ §25). */
    reportLocation(payload) {
        return this.http.post('courier/location', payload);
    }
    myWallet() {
        return this.http.get('courier/wallet');
    }
    /** My wallet movements, newest first — the courier's own statement. */
    myTransactions(query) {
        return this.http.getPaginated('courier/wallet/transactions', {
            query,
        });
    }
    /**
     * Courier declaring cash handed to the cashier; awaits confirmation.
     *
     * `branchId` is optional: the server falls back to the courier's own branch,
     * which is what the app almost always wants.
     */
    declareHandover(amount, branchId) {
        return this.http.post('courier/handovers', { amount, branchId });
    }
    /** My hand-offs and whether a cashier has confirmed them yet. */
    myHandovers() {
        return this.http.getPaginated('courier/handovers');
    }
}
exports.CourierAppResource = CourierAppResource;
//# sourceMappingURL=delivery.js.map